{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Alle Optionen sehen",
  "Spoiler_Reveal_Tooltip": "Zum Enthüllen hier klicken",
  "VerticalEmbed_Event_Error_Subtitle": "Diese Veranstaltung wurde gelöscht, ersetze sie durch eine andere.",
  "Viewer_Toolbar_Twitter_Tooltip": "Twittern",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element wurde verborgen",
  "Spoiler_Reveal_Video_CTA": "Video enthüllen",
  "VerticalEmbed_Pricing_Plan": "Nur Preisplan",
  "Image_Expand_Button_AriaLabel": "Bild ausdehnen",
  "VerticalEmbed_From_Price": "Ab",
  "Poll_Viewer_ShowAllResults_CTA": "Alle Ergebnisse ansehen",
  "Spoiler_Reveal_Image_Placeholder": "Dieses Bild enthält einen Spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Slider suchen",
  "VerticalEmbed_Error_Subtitle": "Dieses Element wurde gelöscht, ersetze es durch ein anderes Element.",
  "Poll_Viewer_Multiselect_Footer": "Du kannst für mehr als eine Antwort stimmen.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mehr Audio-Steuerelemente anzeigen",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Service konnte nicht geladen werden",
  "Fullscreen_Close_Button_AriaLabel": "Schließen",
  "VerticalEmbed_Event_Fetch_Error_Title": "Veranstaltung konnte nicht geladen werden",
  "UploadFile_Viewer_Loader": "{{fileType}} wird geladen",
  "Polls_Plugin_User_Avatar_Alt": "Nutzer-Avatar",
  "Preview_ReadMore_Label": "Weiterlesen",
  "Spoiler_Insert_Tooltip": "Vorschau",
  "VerticalEmbed_Product_Fetch_Error_Title": "Produkt konnte nicht geladen werden",
  "Fullscreen_Shrink_Button_AriaLabel": "Verkleinern",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volumen",
  "Spoiler_Reveal_Gallery_Placeholder": "Diese Galerie enthält einen Spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Erweitern",
  "VerticalEmbed_Bookings_Button": "Jetzt buchen",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Stummschaltung aufheben",
  "Spoiler_Reveal_Gallery_CTA": "Galerie enthüllen",
  "Poll_Viewer_ShowLess_CTA": "Weniger anzeigen",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Stummschalten",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} unbekannte",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Folgen",
  "VerticalEmbed_Products_Button": "Jetzt kaufen",
  "Poll_Viewer_Toast_Error_ServerDown": "Die Verbindung zum Server ist nicht möglich. Versuche es später nochmal.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} Person hat für diese Antwort gestimmt",
  "Poll_Viewer_VoteCount": "{{number}} Stimmen",
  "VerticalEmbed_Events_Button": "Jetzt anmelden",
  "Spoiler_Reveal_Image_CTA": "Bild enthüllen",
  "Poll_Viewer_Toast_Error_Connection": "Keine Internetverbindung. Überprüfe deine Verbindung.",
  "Poll_Viewer_Visibility_Owner_Footer": "Nur du kannst die Ergebnisse sehen.",
  "VerticalEmbed_Booking_Error_Title": "Service wurde gelöscht",
  "VerticalEmbed_Product_Error_Title": "Produkt wurde gelöscht",
  "VerticalEmbed_Fetch_Error_Subtitle": "Elementinformationen können nicht geladen werden.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} Personen haben für diese Antwort gestimmt",
  "VerticalEmbed_Event_Error_Title": "Veranstaltung wurde gelöscht",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element wurde erweitert",
  "Audio_Plugin_Cover_Alt": "Audio-Cover",
  "Spoiler_Reveal_Video_Placeholder": "Dieses Video enthält einen Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Es gab ein technisches Problem. Überprüfe deine Verbindung und versuche es erneut.",
  "VerticalEmbed_Fetch_Error_Title": "Element konnte nicht geladen werden",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Dieses Produkt wurde gelöscht. Ersetze es durch ein anderes Produkt.",
  "VerticalEmbed_Booking_Error_Subtitle": "Dieser Service wurde gelöscht. Ersetze ihn durch einen anderen.",
  "Preview_SeeFullPost_Label": "Gesamten Beitrag ansehen",
  "UploadFile_Viewer_Download": "{{fileType}} herunterladen",
  "VerticalEmbed_Units_Hour": "{{hours}} Std.",
  "VerticalEmbed_Units_Minute": "{{minutes}} Min.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Es gab ein technisches Problem. Überprüfe deine Verbindung und versuche es erneut.",
  "VerticalEmbed_Error_Button": "Ersetzen",
  "VerticalEmbed_Error_Title": "Element wurde gelöscht",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Es gab ein technisches Problem. Überprüfe deine Verbindung und versuche es erneut.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
